export const PREOFFERS = 'available-factoring';

export const OFFERS = 'available-offers';

export const ORDERING = 'ordering';

export const INITIAL_SHOPPING_CART_DIALOG_VALUE = { isOpen: false, type: null };
